export const MUX_PLAYBACK_RATES = Array.from({ length: 36 }, (_, index) =>
  Number((0.25 + index * 0.05).toFixed(2)),
)

// THE TWO MASTER VSLs. Two, and only two, and there is no VSL page: the videos
// live inside the pages that sell. The COACHING master plays on /mentorship,
// /bootcamp and /calls; the DONE-FOR-YOU master on /online-dating-concierge,
// /ai-photos and /profile-makeover. The landing page carries BOTH, side by side
// in the two-lane offer section, because a page with two videos cannot float
// one of them.
//
// Both are 9:16 portrait (source 1080x1920, verified against the Mux thumbnail
// at 960x1707), so every call site passes aspect="portrait" - a landscape frame
// would pillarbox them into black bars.
//
// Each record carries its own Mux analytics labels alongside the playback id.
// They travel together deliberately: a page that names a video also names it in
// the Mux dashboard, so two pages playing the same master still report under one
// honest label instead of whatever each call site invented.
export const COACHING_VSL = {
  playbackId: "rhFsJgvDhPBdoki02HXlSBnqb00019LT701H1DGSsiOVK00s",
  videoId: "coaching-master-vsl",
  videoTitle: "Coaching master VSL",
} as const

export const DFY_VSL = {
  playbackId: "NfdfJ9p91mWPug02027HgOdU018EO1DBcB7qRt6C5028tUE",
  videoId: "dfy-master-vsl",
  videoTitle: "Done-For-You master VSL",
} as const

// The bootcamp had its own sales video. It is RETIRED and its Mux asset is
// deleted, so there is no BOOTCAMP_VSL_PLAYBACK_ID and no /bootcamp#watch email
// link any more. /bootcamp plays the coaching master VSL, like the other two
// coaching pages. Do not reintroduce a bootcamp-only video constant.
